import { Component, input, OnChanges, output, SimpleChanges } from '@angular/core';
import { IRouteAlteration } from 'src/app/models';
import { AlterationStatus } from 'src/app/models/enums';
import { LiteralService, UtilsService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { images } from 'src/images';

@Component({
  selector: 'app-route-alterations',
  templateUrl: './route-alterations.component.html',
  styleUrl: './route-alterations.component.scss',
  standalone: false
})
export class RouteAlterationsComponent implements OnChanges {
  readonly alterations = input<IRouteAlteration[]>();
  readonly map = input<google.maps.Map>();
  readonly newAlteration = input<boolean>();
  readonly onGoBack = output();
  readonly onChangeAlteration = output<IRouteAlteration>();
  readonly onNewAlteration = output();
  readonly onOpenAlterationDetail = output();
  readonly onDuplicateAlteration = output();

  public images = images;
  public TooltipPosition = TooltipPosition;

  public alterationsData: any = [];
  public selectedAlteration: any = null;

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['alterations']) {
      this.alterationsData = changes['alterations'].currentValue.map((alteration: IRouteAlteration) => ({
        id: alteration.id?.toString(),
        value: alteration,
        label: alteration.name!,
        img: alteration.active ? images.alterations.active : images.alterations.inactive,
        alt: alteration.active ? AlterationStatus.ACTIVE : AlterationStatus.INACTIVE
      }));
      const updatedList: IRouteAlteration[] = changes['alterations'].currentValue;
      const stillSelected = updatedList.find((a: IRouteAlteration) => a.id === this.selectedAlteration?.id);
      if (stillSelected) {
        this.selectedAlteration = stillSelected;
        this.changeAlteration({ value: stillSelected });
      } else if (updatedList.length > 0) {
        this.changeAlteration({ value: updatedList[0] });
      } else {
        this.changeAlteration({ value: null });
      }
    }
  }

  changeAlteration(event: any) {
    this.selectedAlteration = event.value;
    this.onChangeAlteration.emit(event.value);
  }

  onClickAlterationDetail() {
    this.onOpenAlterationDetail.emit();
  }

  duplicateAlteration() {
    this.onDuplicateAlteration.emit();
  }

  goBack() {
    this.onGoBack.emit();
  }

}
